import React, { useState, useRef, useEffect } from "react";
import "../index.css";
function CustomDatePicker({ label, date, setDate }) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the input,
      // then close the input focus
      if (
        isFocused &&
        inputRef.current &&
        !inputRef.current.contains(e.target)
      ) {
        setIsFocused(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isFocused]);

  return (
    <div className="date-picker-container">
      <label className={isFocused || date ? "label shrink" : "label"}>
        {label}
      </label>
      <input
        ref={inputRef}
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={isFocused || date ? "color-black" : "date-input"}
      />
    </div>
  );
}

export default CustomDatePicker;
